import { render, staticRenderFns } from "./InputList.vue?vue&type=template&id=3ffc7135&"
import script from "./InputList.vue?vue&type=script&lang=js&"
export * from "./InputList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports